import React from 'react'
import { ToolbarItemProps } from './Toolbar.types'

import styles from '../Toolbar/Toolbar.module.css'

export const ToolbarItem: React.FC<ToolbarItemProps> = ({ children }) => {
  return <li className={styles.item}>{children}</li>
}
